<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.dkzg1">&nbsp; &nbsp; &nbsp;
        <img :src="images.dkzg2">
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">多辊轧钢机</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">本公司设计及提供二辊，三辊，四辊，六辊等各式多辊轧钢机。</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        dkzg1: require("../../../assets/img/common/dkzg1.jpg"),
        dkzg2: require("../../../assets/img/common/dkzg2.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/dkzg.vue